export default {
    USER_RECEIVED: 'USER_RECEIVED',

    INVITE_RECEIVED: 'INVITE_RECEIVED',
    INVITE_REVOKED: 'INVITE_REVOKED',

    TEAM_MEMBER_REMOVED: 'TEAM_MEMBER_REMOVED'
};
